var router = require('pjax').Router;
import fieldForm from './form.js';
var index = require('./index.js');

router.get('field/field/([a-zA-Z]+)', fieldForm);
router.get('field/([a-zA-Z]+)', fieldForm);
router.get('field', index);
